import { lazy } from "react";
import { Route } from "react-router-dom";

import { pageNames } from "@shared/routes/pageNames";

const MyAccount = lazy(() => import("@profile/pages/MyAccount"));
const AccountCanceled = lazy(() => import("@profile/pages/AccountCanceled"));
const UpdateEmail = lazy(() => import("@profile/pages/UpdateEmail"));
const UpdatePassword = lazy(() => import("@profile/pages/UpdatePassword"));
const UpdatePhone = lazy(() => import("@profile/pages/UpdatePhone"));
const UpdateSocialName = lazy(() => import("@profile/pages/UpdateSocialName"));

export function ProfilePrivateRouter() {
	return (
		<>
			<Route path={pageNames.account.path} element={<MyAccount />} />
			<Route
				path={pageNames.accountCanceled.path}
				element={<AccountCanceled />}
			/>
			<Route path={pageNames.updateEmailACP.path} element={<UpdateEmail />} />
			<Route path={pageNames.updatePhoneACP.path} element={<UpdatePhone />} />
			<Route
				path={pageNames.updateSocialName.path}
				element={<UpdateSocialName />}
			/>
			<Route
				path={pageNames.updatePasswordACP.path}
				element={<UpdatePassword />}
			/>
		</>
	);
}
